import { logger } from '@/util/logger';

const $ = window.$;
window.dateRangeSelectors = {};
// Fires when the date chooser's value is changed by a method other than the date range selector.
// Attached to ValueChanged event server-side
window.dateChooserValueChanged = function(objDateChooser) {
	var $dateRangeDropdown = window.dateRangeSelectors[document.getElementById(objDateChooser.Id).getAttribute('data-target')].$outer;

	// set date range value to custom.
	$dateRangeDropdown.val('custom');
};

export default function(id) {
	this.id = id;
	this.$outer = $('#' + id);
	this.startSelector;
	this.endSelector;
	window.dateRangeSelectors[id] = this;

	var _ranges = ['last_week', 'last_month', 'last_quarter', 'last_year', 'current_week', 'current_month', 'current_quarter', 'current_year'];

	this.setRange = function(range) {
		if (_ranges.indexOf(range) < 0) {
			logger.warn(range + ' is not an acceptable range');
			return;
		}

		// get values we will use to calculate date range
		var d = new Date();
		var cdv = d.getDay();
		var cmv = d.getMonth();
		var cyv = d.getFullYear();
		var dayNumber = d.getDate();
		var monthStart;
		var monthEnd;

		var startDate = d;
		var endDate = d;

		switch (range) {
		// Note: When creating a date object, setting 0 for day gives the last day of the previous month.
		// A negtive value for day subtracts that number of days from the last day of the previous month.
		// e.g. new Date(2016,1,-3) returns Thu Jan 28 2016 00:00:00 GMT-0500 (Eastern Standard Time)
		// Months are zero-indexed
		case 'last_week':
			startDate = new Date(cyv, cmv, dayNumber - cdv - 7);
			endDate = new Date(cyv, cmv, dayNumber - cdv - 1);
			break;
		case 'last_month':
			startDate = new Date(cyv, cmv - 1, 1);
			endDate = new Date(cyv, cmv, 0);
			break;
		case 'last_quarter':
			monthEnd = cmv - (cmv % 3);
			monthStart = monthEnd - 3;

			startDate = new Date(cyv, monthStart, 1);
			endDate = new Date(cyv, monthEnd, 0);
			break;
		case 'last_year':
			startDate = new Date(cyv - 1, 0, 1);
			endDate = new Date(cyv, 0, 0);
			break;
		case 'current_week':
			startDate = new Date(cyv, cmv, dayNumber - cdv);
			break;
		case 'current_month':
			startDate = new Date(cyv, cmv, 1);
			break;
		case 'current_quarter':
			monthStart = cmv - (cmv % 3);

			startDate = new Date(cyv, monthStart, 1);
			break;
		case 'current_year':
			startDate = new Date(cyv, 0, 1);
			break;
		default:
			break;
		}
		this.startSelector.setValue(startDate);
		this.endSelector.setValue(endDate);

	};

	var _attachEvents = function() {
		var that = this;
		this.$outer.on('change', function updateRange() {
			var range = this.value;
			if (range) {
				that.setRange(range);
			}
		});
	};

	var _cacheSelectors = function() {
		this.$outer = $('#' + id);
		this.startSelector = window.igdrp_getComboById(this.$outer.data().targetStart);
		this.endSelector = window.igdrp_getComboById(this.$outer.data().targetEnd);
	};

	this.init = function() {
		_cacheSelectors.call(this);
		_attachEvents.call(this);

		var s = this.startSelector;
		var e = this.endSelector;

		// For some reason Chrome is only setting the datechooser's "text" not it's value on Postback.
		// So check if we have text but no value on init and if so, set text as value.
		if (!s.getValue() && s.getText()) {
			s.setValue(s.getText());
		}

		if (!e.getValue() && e.getText()) {
			e.setValue(e.getText());
		}
	};
}